import { render } from "./member_type_select.vue?vue&type=template&id=2b65fbce&scoped=true"
import script from "./member_type_select.vue?vue&type=script&lang=js"
export * from "./member_type_select.vue?vue&type=script&lang=js"

import "./member_type_select.vue?vue&type=style&index=0&id=2b65fbce&lang=scss&scoped=true"
import "./member_type_select.vue?vue&type=style&index=1&id=2b65fbce&lang=scss"

import exportComponent from "F:\\workspace\\custom\\sdxlxh\\ShanDongXinLiZiXun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b65fbce"]])

export default __exports__